import { Tenant } from '@core/Entities/App/Tenants.entity';
import { Locale } from '@core/Entities/Locale/Locale.entity';
import { FilterKey } from '@core/Entities/Search/QueryParams.entity';
import { Filter } from '@core/Entities/Search/SearchFilters/Filter.entity';
import { createPathFromFilters } from '@core/Utils/Search/CreatePathFromFilters';
import { getFilterFromArray } from '@core/Utils/SearchFilters/GetFilterFromArray';

import { applyFilterChanges } from './ApplyFiltersChange';

/**
 * Given a list of filters and a filter ID -
 * returns a function that creates a link for a single filter value.
 * If a filter value is already selected, the link will remove it.
 * Inversely, if a filter value is not selected, the link will add it.
 */
export const createFiltersLinkForFilterValue = ({
  filters,
  filterId,
  locale,
  tenant,
}: {
  filters: Filter[];
  filterId: FilterKey;
  locale: Locale;
  tenant: Tenant | undefined;
}) => {
  const filter = getFilterFromArray(filterId, filters);
  const selectedOptions = new Set(filter?.value ?? []);
  return (value: string) => {
    const selected = new Set(selectedOptions);
    if (!selected.has(value)) {
      selected.add(value);
    } else {
      selected.delete(value);
    }
    const filterValue = Array.from(selected);
    const newFilters = applyFilterChanges(filters, [
      {
        id: filterId,
        value: filterValue,
      },
    ]);
    const path = createPathFromFilters(newFilters ?? [], locale, 'autos');
    if (!tenant) return path;

    // strip the locale from the path
    const split = path.split('/').filter(Boolean);
    if (split.at(0) === locale) return '/' + split.slice(1).join('/');

    return path;
  };
};
